import React from 'react';
import {
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalTitle,
    CloseButton,
    ModalBody,
    FormGroup,
    Label,
    RadioGroup,
    RadioLabel,
    RadioInput,
    SliderGroup,
    Slider,
    SliderValue
} from '../../styles/ClockSettingsModal.styles';

const ClockSettingsModal = ({ isOpen, onClose, settings, onSettingsChange }) => {
    if (!isOpen) return null;

    const handleFormatChange = (e) => {
        onSettingsChange({ ...settings, hour12: e.target.value === '12' });
    };

    const handleSizeChange = (e) => {
        onSettingsChange({ ...settings, clockSize: parseFloat(e.target.value) });
    };

    return (
        <ModalOverlay onClick={onClose}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
                <ModalHeader>
                    <ModalTitle>Clock Settings</ModalTitle>
                    <CloseButton onClick={onClose}>&times;</CloseButton>
                </ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <Label>Time Format</Label>
                        <RadioGroup>
                            <RadioLabel>
                                <RadioInput
                                    type="radio"
                                    name="time-format"
                                    value="12"
                                    checked={settings.hour12}
                                    onChange={handleFormatChange}
                                />
                                12-hour
                            </RadioLabel>
                            <RadioLabel>
                                <RadioInput
                                    type="radio"
                                    name="time-format"
                                    value="24"
                                    checked={!settings.hour12}
                                    onChange={handleFormatChange}
                                />
                                24-hour
                            </RadioLabel>
                        </RadioGroup>
                    </FormGroup>
                    <FormGroup>
                        <Label>Clock Size</Label>
                        <SliderGroup>
                            <Slider
                                type="range"
                                min="2"
                                max="8"
                                step="0.5"
                                value={settings.clockSize}
                                onChange={handleSizeChange}
                            />
                            <SliderValue>{settings.clockSize}rem</SliderValue>
                        </SliderGroup>
                    </FormGroup>
                </ModalBody>
            </ModalContent>
        </ModalOverlay>
    );
};

export default ClockSettingsModal;
